import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import { isValidMotionProp, motion } from "framer-motion";
import { Helmet } from "react-helmet";

import "./styles.css";
import { Link, useSearchParams } from "react-router-dom";
import { filterNumberColor, formatNumber } from "../../utils/formatNumber";
import { useTranslation } from "react-i18next";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const BetRecordDetail = ({
  fontStyle,
  setOpenBetRecordDetail,
  betRecordDetail,
} = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [searchParams, setSearchParams] = useSearchParams();

  const game = searchParams.get("game") || "";

  const numberColor = useMemo(() => {
    const NUMBER = betRecordDetail?.totalWinOrLose || 0;
    if (typeof NUMBER === "string") {
      NUMBER = Number(NUMBER);
    }

    if (NUMBER > 0) {
      return "green.500";
    } else if (NUMBER < 0) {
      return "red.500";
    } else {
      return "white";
    }
  }, [betRecordDetail?.totalWinOrLose]);

  const getFilteredRecords = useMemo(() => {
    return (
      betRecordDetail[game] || {
        totalBet: 0,
        totalWinOrLose: 0,
      }
    );
  }, [game, betRecordDetail]);

  return (
    <>
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="450px"
        minH="400px"
        bgImage={`url('${COMMON_WEB_PATH}/theOne/berRecord/bet_record_background.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        position={"relative"}
        py="20px"
        px="30px"
      >
        <Box
          position="absolute"
          bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_close.png')`}
          bgSize="100% 100%"
          bgPos="center"
          w="50px"
          h="50px"
          top="0px"
          right="0px"
          cursor="pointer"
          onClick={() => {
            setOpenBetRecordDetail(false);
          }}
        ></Box>
        <Box
          display="flex"
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          w="100%"
          h="100%"
          flex={1}
        >
          <Box h="90px" display={"flex"} alignItems={"center"}>
            {/* 標題 */}
            <Text fontSize="37px" fontWeight={900}>
              {game || i18n("請選擇")}
            </Text>
          </Box>

          <Box
            flex={1}
            py="10px"
            display={"flex"}
            flexDir={"column"}
            gap="5px"
            alignItems={"center"}
            justifyContent={"center"}
          >
            {/* 投注標籤 */}
            <Box>
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/bet_tag.png`}
              />
            </Box>

            <Text
              {...fontStyle}
              bgGradient="linear(to-b, #FFF18E, #F5A623)"
              bgClip="text"
              sx={{
                WebkitTextStroke: "1px #4B1E00",
              }}
            >
              {formatNumber(getFilteredRecords?.totalBet || 0)}
            </Text>

            <Box>
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/winloss_tag.png`}
              />
            </Box>

            <Text {...fontStyle} color={numberColor}>
              {formatNumber(getFilteredRecords?.totalWinOrLose || 0)}
            </Text>
          </Box>
        </Box>
      </ChakraBox>{" "}
    </>
  );
};

export default BetRecordDetail;
